/**
 * Navbar Component - Mobile First
 */

import React, { useState, useEffect } from 'react';
import { Menu, X, Heart } from 'lucide-react';

const NAV_LINKS = [
  { path: '/', label: 'الرئيسية' },
  { path: '/features', label: 'المميزات' },
  { path: '/how-it-works', label: 'كيف يعمل؟' },
  { path: '/faq', label: 'الأسئلة الشائعة' },
  { path: '/contact', label: 'تواصل معنا' },
];

export default function Navbar({ currentPath, navigate, onLoginClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path) => {
    navigate(path);
    setIsOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
          
          {/* Logo */}
          <button 
            onClick={() => handleNavClick('/')}
            className="flex items-center gap-2 group"
          >
            <span className="text-2xl md:text-3xl">👩‍🦳</span>
            <div className="flex flex-col">
              <span className="text-lg md:text-xl font-bold bg-gradient-to-r from-rose-600 to-purple-600 bg-clip-text text-transparent">
                خالتي هيلة
              </span>
              <span className="text-[10px] text-gray-500 hidden md:block">نربط راسين بالحلال</span>
            </div>
            <Heart className="w-4 h-4 text-rose-500 fill-rose-500 group-hover:scale-125 transition-transform" />
          </button>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNavClick(link.path)}
                className={`text-sm font-medium transition-colors hover:text-rose-600 ${
                  currentPath === link.path ? 'text-rose-600' : 'text-gray-700'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={onLoginClick}
              className="px-4 py-2 text-sm font-medium text-rose-600 hover:text-rose-700 transition-colors"
            >
              تسجيل الدخول
            </button>
            <button
              onClick={onLoginClick}
              className="px-5 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-rose-500 via-red-500 to-purple-600 rounded-full hover:shadow-lg hover:scale-105 transition-all"
            >
              سجّل الآن
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-rose-600 transition-colors"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-4' : 'max-h-0'
        }`}>
          <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-xl p-4 space-y-2">
            {NAV_LINKS.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNavClick(link.path)}
                className={`w-full text-right px-4 py-3 rounded-xl font-medium transition-all ${
                  currentPath === link.path 
                    ? 'bg-rose-50 text-rose-600' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.label}
              </button>
            ))}
            
            <div className="border-t pt-3 mt-3 flex gap-2">
              <button
                onClick={onLoginClick}
                className="flex-1 py-3 text-sm font-medium text-rose-600 border-2 border-rose-200 rounded-xl hover:bg-rose-50 transition-all"
              >
                تسجيل الدخول
              </button>
              <button
                onClick={onLoginClick}
                className="flex-1 py-3 text-sm font-semibold text-white bg-gradient-to-r from-rose-500 to-purple-600 rounded-xl hover:shadow-lg transition-all"
              >
                سجّل الآن
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
